import Styles from './LanguageInputField.module.scss'
import { LanguageInput, LanguageVariant } from './LanguageInput'
import { useLastUsedLanguage } from 'hooks/queries/useLastUsedLanguage'
import { useField } from 'formik'
import { useEffect } from 'react'
import { Field } from 'components/Wizards/Field/Field'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  variant?: LanguageVariant
}

const FormikLanguageInput = ({ variant }: Props) => {
  const defaultLanguageQuery = useLastUsedLanguage()
  const [languageField, , { setValue: setLanguage }] = useField('language')
  const defaultLanguage = defaultLanguageQuery?.data?.language
  const { isMobile } = useResponsiveDesign()

  useEffect(() => {
    if (!!defaultLanguage && !languageField.value) {
      setLanguage(defaultLanguage)
    }
  }, [defaultLanguage, languageField.value, setLanguage])

  if (defaultLanguageQuery.isLoading) {
    return (
      <div className={Styles.loadingContainer}>
        <TextFieldLoadingState />
      </div>
    )
  }

  return (
    <LanguageInput
      languageValue={languageField.value}
      onLanguageChange={setLanguage}
      wrapperClassName={isMobile ? Styles.languageFieldWrapper : undefined}
      contentsClassName={isMobile ? Styles.languageFieldButton : undefined}
      popoverClassName={isMobile ? Styles.languageFieldPopover : undefined}
      variant={variant}
    />
  )
}

export const InlineLanguageInputField = ({ variant }: Props) => (
  <div className={Styles.fieldContainer} data-testid="language-input-button">
    <span className={Styles.label}>Generate in </span>
    <FormikLanguageInput variant={variant} />
  </div>
)

export const LanguageInputField = ({
  variant,
  labelType = 'heading',
  label = 'Generate in',
}: Props & { labelType?: 'text' | 'heading'; label?: string }) => (
  <Field label={label} labelType={labelType}>
    <div className={Styles.formFieldContainer}>
      <FormikLanguageInput variant={variant} />
    </div>
  </Field>
)
